import { AgnosticCoupon } from './vsf/agnostic-coupon';

/**
 * MatchesCart: The Discount Code is active and contains at least one active and valid Cart Discount.
 * DoesNotMatchCart: The Discount Code is active and contains at least one active and valid Cart Discount, but none of them matches the cart.
 * NotValid: The Discount Code is not valid or does not contain any valid Cart Discounts. Based on validFrom and validUntil dates.
 * NotActive: The Discount Code is not active or does not contain any active Cart Discounts.
 */
export enum CartDiscountStates {
  matchesCart = 'MatchesCart',
  notActive = 'NotActive',
  notValid = 'NotValid',
  doesNotMatchCart = 'DoesNotMatchCart',
  maxApplicationReached = 'MaxApplicationReached',
  applicationStoppedByPreviousDiscount = 'ApplicationStoppedByPreviousDiscount',
}

export interface CartDiscountType extends AgnosticCoupon {
  state: CartDiscountStates;
}
